export default __webpack_public_path__ + "static/mark-30d6976c398453b8a9ac131675712ff2.png";